/**
 * @ngdoc overview
 * @name routesValidation
 * @description
 * Validates if the user is authenticated.
 *
 * @param {Service} $location    To redirect the user if something goes wrong.
 * @param {Object}  $rootScope   To subscribe to the route change events.
 * @param {Service} ccaSession   To check for an existent session.
 * @param {Service} errorHandler To show any errors.
 * @param {Array}   MENU_ITEMS   Array of menu items.
 * @memberof root
 */
const routesValidation = (
  $location,
  $rootScope,
  ccaSession,
  errorHandler,
  MENU_ITEMS,
) => {
  'ngInject';

  const removeValidation = $rootScope.$on('$routeChangeStart', () => {
    const current = $location.path();
    ccaSession.setActiveSection(MENU_ITEMS.find((item) => item.regExpPath.exec(current)));

    if (current.includes('/logout')) {
      return;
    }

    // Check if the _updated_ flag was used and show error.
    if ($location.search().updated === 'true') {
      errorHandler.showErrorMessage('A new version has been released. Please login again');
    }

    if (!ccaSession.isAuthenticated()) {
      // If the user is not logged in, redirect to the login page.
      $location.url('/login');
    } else if (!ccaSession.isAccountSelected()) {
      // If the user has not selected any account, redirect to the accounts page.
      $location.url('/accounts');
    } else if (current.includes('/login')) {
      /**
       * If the user is already logged and we are in that pages,
       * redirect to the home page.
       */
      $location.url('/');
    }
  });

  $rootScope.$on('$destroy', () => {
    removeValidation();
  });
};

export default routesValidation;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/eventSubscribers/routesValidation.js